export const setUploadItem = (urls = "") => {
  if (!urls) {
    return [];
  }
  return urls.split(",").map((url) => {
    const uuid = Math.random() * 100000;
    return {
      thumbUrl: url,
      url,
      uid: -uuid, // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
      name: `${uuid}`, // 文件名
      status: "done", // 状态有：uploading done error removed，被 beforeUpload 拦截的文件没有 status 属性
      // response: '{"status": "success"}', // 服务端响应内容
      // linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
    };
  });
};
